function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridCardComponent from '@/components/work_environments/GridCardComponent';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import firebase from 'firebase';
import { mapState } from 'vuex';
export default {
  name: 'SearchPage',
  components: {
    GridCardComponent: GridCardComponent
  },
  props: {},
  data: function data() {
    return {
      label: {
        search: this.translate('attributes.label.search')
      },
      cards: [],
      q: ''
    };
  },
  methods: {
    sendToSearch: function sendToSearch() {
      this.$router.push('/attributes/search/list?q=' + this.q);
    },
    getCategories: function getCategories() {
      var _this = this;
      this.cards = [];
      firebase.storage().ref('attributes_marketplace/Personalizados.png').getDownloadURL().then(function (url) {
        console.log("Image url: ".concat(url));
        _this.cards.push({
          title_es: 'Mis grupos',
          title_en: 'My groups',
          subtitle_es: 'Agrupaciones de atributos creados por los usuarios de la organización enfocados en un caso de uso específico',
          subtitle_en: 'Groupings of attributes created by the organization\'s users focused on a specific use case',
          flex: 4,
          color: '#F1F1F1',
          urlImage: url,
          path: '/attributes/groups',
          access: true
        }, {
          title_es: 'Atributos creados por el usuario',
          title_en: 'User-created attributes',
          subtitle_es: 'Atributos creados mediante script\'s provenientes de las tablas de Intercorp',
          subtitle_en: 'Atributos creados mediante script\'s provenientes de las tablas de Intercorp',
          flex: 4,
          color: '#F1F1F1',
          urlImage: url,
          path: '/attributes/search/user-groups',
          access: true
        });
        UseCasesService.getAttributeMasterCatalog().then(function (response) {
          if (response && response.data) {
            Object.entries(response.data.attribute_source_id).forEach(function (entry) {
              var eliminados = [];
              var _entry = _slicedToArray(entry, 2),
                key = _entry[0],
                value = _entry[1];
              if (value.denied_company_code) {
                Object.entries(value.denied_company_code).forEach(function (denied) {
                  var _denied = _slicedToArray(denied, 2),
                    valor = _denied[1];
                  eliminados.push(valor);
                });
              }
              if (!eliminados.includes(_this.companyCode)) {
                _this.cards.push({
                  id: key,
                  title_es: value.name_es,
                  title_en: value.name_en,
                  subtitle_es: value.description_es,
                  subtitle_en: value.description_en,
                  flex: 4,
                  color: '#F1F1F1',
                  urlImage: value.attribute_group_design,
                  path: '/attributes/search/list?c=' + value.alias,
                  access: true
                });
              }
            });
          }
        });
      });
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('attributes.discover_attributes'),
        disabled: true
      }];
    }
  }),
  created: function created() {
    this.getCategories();
  }
};